import styled from "styled-components";

export const StyledProperty = styled.div`

`;